import Vue from "vue";
import { Popup } from "mapbox-gl";
import router from "@/router";
import apolloProvider from "@/services/apollo_provider";
import PopupContent from "@/components/PopupContent";

class LayerManager {
  constructor(map) {
    this.map = map;

    this.map.on("load", () => {
      this.mapReady = true;
    });

    this.map.on("click", "current-layer-fill", (e) => {
      this.popup = new Popup()
        .setLngLat(e.lngLat)
        .setHTML("<div class='popup-dynamic-content'></div>")
        .addTo(this.map);
      this.applyPopupContent(e.features[0].id);
    });

    this.map.on("mousemove", "current-layer-fill", (e) => {
      if (e.features.length === 0) return;
      if (this.hoverArea) {
        this.map.setFeatureState({
          source: "current-layer",
          sourceLayer: "featurelayer",
          id: this.hoverArea }, { hover: false });
      }
      this.hoverArea = e.features[0].id;
      this.map.setFeatureState({
        source: "current-layer",
        sourceLayer: "featurelayer",
        id: this.hoverArea }, { hover: true });
    });

    this.map.on("mouseleave", "current-layer-fill", () => {
      if (this.hoverArea) {
        this.map.setFeatureState({
          source: "current-layer",
          sourceLayer: "featurelayer",
          id: this.hoverArea }, { hover: false });
      }
      this.hoverArea = null;
    });
  }

  updateTileset(tileset) {
    if (!this.mapReady) {
      this.map.on("load", () => this.updateTileset(tileset));
      return;
    }

    this.removeTileset(this.currentTileset);
    this.addTileset(tileset);
  }

  addTileset(tileset) {
    this.currentTileset = tileset;

    if (this.popup) this.popup.remove();

    this.map.addSource("current-layer", {
      type: "vector",
      url: `mapbox://${tileset}`,
      promoteId: { featurelayer: "ID" },
      attribution: "2018 Statistics New Zealand"
    });

    this.map.addLayer({
      id: "current-layer-fill",
      type: "fill",
      source: "current-layer",
      "source-layer": "featurelayer",
      paint: {
        "fill-color": "#666",
        "fill-opacity": ["case",
          ["boolean", ["feature-state", "highlighted"], false],
          0.5,
          ["boolean", ["feature-state", "hover"], false],
          0.5,
          0.2
        ]
      }
    }, "waterway-label");

    this.map.addLayer({
      id: "current-layer-outline",
      type: "line",
      source: "current-layer",
      "source-layer": "featurelayer",
      paint: {
        "line-color": "#333",
        "line-width": ["case",
          ["boolean", ["feature-state", "hover"], false],
          2,
          1
        ]
      }
    }, "waterway-label");
  }

  removeTileset() {
    this.currentTileset = null;
    this.highlightedFeatureId = null;
    if (this.map.getLayer("current-layer-fill")) this.map.removeLayer("current-layer-fill");
    if (this.map.getLayer("current-layer-outline")) this.map.removeLayer("current-layer-outline");
    if (this.map.getSource("current-layer")) this.map.removeSource("current-layer");
  }

  highlightFeature(featureId) {
    if (!this.mapReady) {
      this.map.on("load", () => this.highlightFeature(featureId));
      return;
    }

    if (this.highlightedFeatureId) {
      this.map.setFeatureState({
        source: "current-layer",
        sourceLayer: "featurelayer",
        id: this.highlightedFeatureId }, { highlighted: false });
    }

    this.map.setFeatureState({
      source: "current-layer",
      sourceLayer: "featurelayer",
      id: featureId }, { highlighted: true });

    this.highlightedFeatureId = featureId;
  }

  applyPopupContent(featureIdentifier) {
    /* eslint-disable no-new */
    new Vue({
      el: this.popup.getElement().querySelector(".popup-dynamic-content"),
      components: { PopupContent },
      template: `<PopupContent featureIdentifier="${featureIdentifier}" />`,
      apolloProvider,
      router
    });
  }
}

export default LayerManager;



// WEBPACK FOOTER //
// ./src/components/Map/layer_manager.js